type Props = {
  size?: number;
};

export default function RelinkIcon({ size = 14 }: Props) {
  return (
    <svg width={size} height={size} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.33752 4.52377C7.74366 4.71768 8.09733 5.00622 8.36884 5.36517C8.64034 5.72411 8.82173 6.14297 8.89779 6.58655C8.97384 7.03014 8.94233 7.4855 8.8059 7.91438C8.66948 8.34326 8.43212 8.73314 8.11377 9.05127L5.30127 11.8638C5.0401 12.1249 4.73005 12.3321 4.38882 12.4734C4.04759 12.6148 3.68186 12.6875 3.31252 12.6875C2.56659 12.6875 1.85122 12.3912 1.32377 11.8638C0.796318 11.3363 0.5 10.6209 0.5 9.87502C0.5 9.12909 0.796318 8.41372 1.32377 7.88627L2.42189 6.78814M10.7656 6.39939L11.8638 5.30127C12.3912 4.77382 12.6875 4.05844 12.6875 3.31252C12.6875 2.56659 12.3912 1.85122 11.8638 1.32377C11.3363 0.796318 10.6209 0.5 9.87502 0.5C9.12909 0.5 8.41372 0.796318 7.88627 1.32377L5.07377 4.13627C4.75542 4.45439 4.51806 4.84427 4.38163 5.27316C4.2452 5.70204 4.21369 6.1574 4.28975 6.60098C4.3658 7.04457 4.5472 7.46343 4.8187 7.82237C5.0902 8.18131 5.44388 8.46986 5.85002 8.66377'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
